export function getSelectedFilters(state) {
  const filters = [];
  if (state.catalogOptions.filters && state.catalogOptions.filters.values) {
    state.catalogOptions.filters.values.forEach((filter) => {
      if (filter.model !== null) {
        if (filter.model.value !== undefined || filter.model.length > 0 || (filter.type === 'boolean' && filter.model === true)) {
          filters.push(filter);
        }
      }
    });
  }
  return filters;
}

export function getCurrentFilteringParameters(state) {
  const filteringParameters = {};

  if (state.catalogOptions.filters && state.catalogOptions.filters.values) {
    state.catalogOptions.filters.values.forEach((filter) => {
      if (filter.model !== null && filter.model !== undefined) {
        if (filter.model.value !== undefined) {
          filteringParameters[filter.key] = filter.model.value;
        }
        else if (filter.model.length > 0) {
          filteringParameters[filter.key] = filter.model.join(',');
        }
        else if (filter.type === 'boolean' && filter.model === true) {
          filteringParameters[filter.key] = 'true';
        }
      }
    });
  }
  if (state.searchValue !== undefined && state.searchValue !== null && state.searchValue !== '') {
    filteringParameters.search = state.searchValue;
  }
  filteringParameters.sort = state.selectedSort.option === '' ? 'master' : state.selectedSort.option;
  filteringParameters.page = state.currentPage;

  return filteringParameters;
}
